import { Reducer } from 'redux';
import {
  AddMemberActionTypes,
  MemberState,
  OrganisationActionTypes,
  EditMemberActionTypes
} from './types';

const initialState: MemberState = {
  error: undefined,
  submitting: false,
  fetchingOrgProfile: false,
  data: undefined,
  orgProfile: undefined,
  orgProfileUpdated: false,
  isModalOpen: false,
  gettingOrgTenants: false,
  isNewRecordAdded: false,
  type: 'ADD'
};

const reducer: Reducer<MemberState> = (state = initialState, action: any) => {
  switch (action.type) {
    case AddMemberActionTypes.FETCH_ADD_MEMBER_INIT: {
      return {
        ...state,
        error: undefined,
        submitting: false,
        data: undefined
      };
    }
    case AddMemberActionTypes.OPEN_ADD_MEMBER_MODAL_START:
    case EditMemberActionTypes.OPEN_EDIT_MEMBER_MODAL_START:
      return {
        ...state,
        isModalOpen: action.payload
      };
    case AddMemberActionTypes.FETCH_ADD_MEMBER_REQUEST: {
      return {
        ...state,
        data: undefined,
        submitting: true,
        error: undefined
      };
    }
    case AddMemberActionTypes.FETCH_ADD_MEMBER_SUCCESS: {
      return {
        ...state,
        submitting: false,
        error: undefined,
        data: action.payload,
        isModelOpen: false,
        isNewRecordAdded: true
      };
    }
    case AddMemberActionTypes.FETCH_ADD_MEMBER_FAILURE: {
      return {
        ...state,
        submitting: false,
        error: action.payload,
        data: undefined,
        isModelOpen: false
      };
    }
    case AddMemberActionTypes.REMOVE_ERROR: {
      return {
        ...state,
        error: ''
      };
    }
    case AddMemberActionTypes.UPDATE_NEW_RECORD_ADDED_FLAG: {
      return {
        ...state,
        isNewRecordAdded: action.payload
      };
    }
    case OrganisationActionTypes.UPDATE_ORG_PROFILE_START: {
      return {
        ...state,
        data: undefined,
        orgProfileUpdated: false,
        submitting: true
      };
    }
    case OrganisationActionTypes.UPDATE_ORG_PROFILE_SUCCESS:
    case EditMemberActionTypes.FETCH_EDIT_MEMBER_SUCCESS: {
      return {
        ...state,
        submitting: false,
        orgProfileUpdated: true
      };
    }
    case OrganisationActionTypes.UPDATE_ORG_PROFILE_FAILURE:
    case EditMemberActionTypes.FETCH_EDIT_MEMBER_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
        orgProfileUpdated: false
      };
    case OrganisationActionTypes.FETCH_ORG_PROFILE_START: {
      return {
        ...state,
        orgProfile: undefined,
        fetchingOrgProfile: true
      };
    }
    case OrganisationActionTypes.FETCH_ORG_PROFILE_SUCCESS: {
      return {
        ...state,
        fetchingOrgProfile: false,
        orgProfile: action.payload
      };
    }
    case OrganisationActionTypes.FETCH_ORG_PROFILE_FAILURE:
      return {
        ...state,
        fetchingOrgProfile: false,
        orgProfile: undefined,
        error: action.payload
      };
    case OrganisationActionTypes.CLEAR_ORG_PROFILE:
      return {
        ...state,
        orgProfile: undefined
      };
    case EditMemberActionTypes.FETCH_EDIT_MEMBER_INIT:
      return {
        ...state,
        type: action.payload.type,
        data: action.payload.data
      };
    case EditMemberActionTypes.FETCH_EDIT_MEMBER_REQUEST:
      return {
        ...state,
        submitting: true
      };
    case OrganisationActionTypes.UPDATE_ORG_PROFILE_UPDATE_FLAG:
      return {
        ...state,
        orgProfileUpdated: false
      };
    case OrganisationActionTypes.FETCH_ORG_TENANTS_START: {
      return {
        ...state,
        gettingOrgTenants: true,
        orgTenants: []
      };
    }
    case OrganisationActionTypes.FETCH_ORG_TENANTS_SUCCESS: {
      return {
        ...state,
        gettingOrgTenants: false,
        orgTenants: action.payload
      };
    }
    case OrganisationActionTypes.FETCH_ORG_TENANTS_FAILURE:
      return {
        ...state,
        gettingOrgTenants: false
      };
    default: {
      return state;
    }
  }
};

export { reducer as MemberReducer };
